import { render, staticRenderFns } from "./bidTermination.vue?vue&type=template&id=a6a3be6c&scoped=true"
import script from "./bidTermination.vue?vue&type=script&lang=js"
export * from "./bidTermination.vue?vue&type=script&lang=js"
import style0 from "./bidTermination.vue?vue&type=style&index=0&id=a6a3be6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a3be6c",
  null
  
)

export default component.exports